export const saveInLocalStorage = (value, localStorageKey) => (
    localStorage.setItem(localStorageKey, JSON.stringify(value))
);

export const getFromLocalStorage = (localStorageKey) => JSON.parse(localStorage.getItem(localStorageKey));
